import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';


import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ActivityLog from '../ActivityLog';
import * as Common from '../Common';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import LoginHeader from '../Login_header';
import Menu from '../Menu';


function Master_issuer_list() {
    const navigate = useNavigate();
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [issuerData, setIssuerData] = useState([]);
    const [showAddEditForm, setAddEditFormShow] = useState(false);
    const [showAddNewBtn, setShowAddNewBtn] = useState(true);

    const [srNo, setSrNo] = useState(0);
    const [issuer, setIssuer] = useState("");

    const [remark, setRemark] = useState("");

    const [status, setStatus] = useState(1);
    const [ddActiveOptions, setDdActiveOptions] = useState([]);

    const [userRight, setUserRight] = useState([]);

    const [formMode, setFormMode] = useState('Q'); // Q A E 

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");

    const [showActivityLog, setShowActivityLog] = useState(false);
    const [logObject, setLogObject] = useState({ trantype: "", trannumber: "", trancategory: "" });
    const [tranAuditTrail, setTranAuditTrail] = useState([]);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            setDdActiveOptions([{ name: 'Active', value: "1" }, { name: 'Inactive', value: "0" }]);
            Common.callApi(Common.apiRight, [sid, 'all', 'ISSUER'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            Common.callApi(Common.apiIssuer, [sid, 'listjson'], function (result) {
                setIssuerData(JSON.parse(result));
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    function getList() {
        Common.callApi(Common.apiIssuer, [sid, 'listjson'], function (result) {
            setIssuerData(JSON.parse(result));
        });
    }

    function addNew() {
        setSrNo(0);
        // setActivityLog([]);
        setIssuer("");
        setStatus(1);
        setFormMode('A');
        setAddEditFormShow(true);
        setShowAddNewBtn(false);
    }

    function saveData() {
        if (issuer === "") {
            setMsgText("Please fill Issuer!");
            setMsgBox(true);
        } else if (formMode === 'E' && remark === '') {
            setMsgText('Please fill remark!');
            setMsgBox(true);
        } else {
            var object1 = {
                srno: srNo,
                issuer: issuer,
                act: status,
                branch: 0,
                activitytype: srNo * 1 > 0 ? 'MODIFY' : 'CREATE',
                trancategory: 'M',
                trantype: 'MISUR',
                trannumber: srNo,
                subtranno: 0,
                remark: remark
            };
            var obj2 = {
                TabType: "Edit",
                ALineNo: tranAuditTrail.length + 1,
                AType: "A",
                TType: 'MISUR',
                Issuer: issuer,
                Act: status,
                Remark: remark
            }
            var tran_audit_trail = Common.arrayAddItem(tranAuditTrail, obj2);
            setTranAuditTrail(tran_audit_trail);
            Common.callApi(Common.apiIssuer, [sid, 'save', srNo, JSON.stringify(object1), JSON.stringify(tran_audit_trail)], function (result) {
                let resp = JSON.parse(result);
                if (resp.status) {
                    setAddEditFormShow(false);
                    setShowAddNewBtn(true);
                    setRemark("");
                    getList();
                    setTranAuditTrail([]);
                    setMsgText(resp.message);
                    setMsgBox(true);
                } else {
                    setMsgText(resp.message);
                    setMsgBox(true);
                }
            });
        }
    }

    const cancelConfirm = () => {
        if (formMode === "A" || formMode === "E") {
            setMsgTextYN('Do you really want to exit ?');
            setMsgBoxYN(true);
        } else {
            cancelData();
        }
    }

    const cancelData = () => {
        setMsgBoxYN(false);
        setAddEditFormShow(false);
        setShowAddNewBtn(true);
        setShowActivityLog(false);
    }

    // function cancelData() {
    //     setAddEditFormShow(false);
    //     setShowAddNewBtn(true);
    // }

    function fillEditForm(id) {
        setFormMode('Q');
        setShowActivityLog(false);
        // setActivityLog([]);
        Common.callApi(Common.apiIssuer, [sid, 'detail', id], function (result) {
            let resp = JSON.parse(result);
            setSrNo(resp.srno);
            setIssuer(resp.issuer);
            setStatus(resp.active);
            setAddEditFormShow(true);
            setShowAddNewBtn(false);
        });
    }

    const editData = () => {
        setFormMode('E');
    }

    const exportFile = () => {
        var obj = {
            right: 'ISSUER'
        }
        Common.callDownloadApiPost(Common.apiReport, "post", [sid, JSON.stringify(obj)]);
    }

    const btnActivityLog = () => {
        setShowActivityLog(true);
        setLogObject({ trantype: "MISUR", trannumber: srNo, trancategory: "M" });
    }

    return (
        <>
            <LoginHeader />
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>Issuer Master</h1>
                    </Col>
                </Row>
                {showAddNewBtn ?
                    <Row>
                        <Col>
                            {userRight.add === "1" ?
                                <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={addNew}>Add New</Button>
                                : null}
                            {
                                userRight.query === "1" ?
                                    <>&nbsp;
                                        <Button variant="outline-primary" className='buttonStyle' size="sm" onClick={exportFile}>Export</Button>
                                    </>
                                    : null
                            }
                        </Col>
                    </Row>
                    : null
                }

                <Row><Col>&nbsp;</Col></Row>
                {showAddEditForm ?
                    <>
                        <Row>
                            <Col className="divContentCenter">
                                {/*Add Edit Form  className="mb-3" className="divContentCenter" */}
                                <div className="maxFormWidth">
                                    <Form>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Serial Number</Form.Label>
                                                    <Form.Control type="text" placeholder="Serial Number" value={srNo} disabled />
                                                </Form.Group>
                                            </Col>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>issuer<span className="mandatory text-danger">*</span></Form.Label>
                                                    <Form.Control type="text" placeholder="Issuer" maxLength={50}
                                                        value={issuer}
                                                        onChange={(e) => Common.validateAlpValue(e.target.value, setIssuer)}
                                                        autoComplete="off"
                                                        disabled={formMode === 'Q'} />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Status</Form.Label>
                                                    <Form.Select
                                                        value={status}
                                                        onChange={(e) => setStatus(e.target.value)}
                                                        disabled={formMode === 'Q'}
                                                    >
                                                        {ddActiveOptions.map((res) =>
                                                            <option key={res.value} value={res.value}>{res.name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col>&nbsp;</Col>
                                        </Row>
                                        {
                                            formMode === 'E' ?
                                                <>
                                                    <Row>
                                                        <Col>
                                                            <Form.Group>
                                                                <Form.Label>Remark<span className="mandatory text-danger">*</span></Form.Label>
                                                                <Form.Control type="text" placeholder="Remark" maxLength={50}
                                                                    value={remark}
                                                                    onChange={(e) => Common.validateAlpValue(e.target.value, setRemark)}
                                                                    autoComplete="off"
                                                                    required />
                                                            </Form.Group>
                                                        </Col>
                                                        <Col>&nbsp;</Col>
                                                        <Col>&nbsp;</Col>
                                                        <Col>&nbsp;</Col>
                                                    </Row>
                                                </> :
                                                null
                                        }
                                        <Row>
                                            <Col>&nbsp;</Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {/* <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() => saveData()}>Save</Button>&nbsp;
                                                <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() => cancelData()}>Cancel</Button> */}

                                                <Button variant="outline-danger" className='buttonStyle' size="sm" onClick={() =>
                                                    cancelConfirm()}>Back</Button>&nbsp;&nbsp;

                                                {
                                                    (userRight.edit === "1" && formMode === 'Q') ? <>
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            editData()}>Edit</Button>&nbsp;
                                                    </> : null
                                                }
                                                {
                                                    (userRight.edit === "1" && formMode === 'E') || (userRight.add === "1" && formMode === 'A') ? <>
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            saveData()}>Save</Button>&nbsp;
                                                    </> : null
                                                }
                                                {
                                                    (userRight.query === "1" && (formMode === 'E' || formMode === 'Q')) ? <>
                                                        <Button variant="outline-success" className='buttonStyle' size="sm" onClick={() =>
                                                            btnActivityLog()}>Activity Log</Button>&nbsp;
                                                    </> : null
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>&nbsp;</Col>
                                        </Row>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            {
                                showActivityLog &&
                                <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
                            }
                        </Row>
                    </>
                    :
                    <>
                        <Row>
                            <Col >
                                <Table responsive striped bordered hover>
                                    <thead>
                                        <tr>
                                            {userRight.edit === "1" ? <th></th> : null}
                                            <th className="textRight">Sr No</th>
                                            <th >Issuer</th>
                                            <th >Status</th>
                                        </tr>
                                    </thead>
                                    <tbody id="tblBody">
                                        {issuerData.map((res) =>
                                            <tr key={res.issuer_id}>
                                                {userRight.edit === "1" ?
                                                    <td className="textCenter" >
                                                        <span className="handCursor" onClick={() => fillEditForm(res.issuer_id)} >
                                                            <div className="colorThemeBlue"><FontAwesomeIcon icon={faEye} /></div>
                                                        </span>
                                                    </td>
                                                    : null
                                                }
                                                <td className="textRight">{res.issuer_id}</td>
                                                <td>{res.issuer_name}</td>
                                                <td>{res.issuer_active}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    </>
                }


            </Container>
            <ActivityLog logObject={logObject} show={showActivityLog} onHide={() => setShowActivityLog(false)} />
            {/* <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div> */}

            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
            </div>
        </>
    );
}
export default Master_issuer_list;